import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 33.6 33.5",
	style: { enableBackground: "new 0 0 33.6 33.5" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.user-icon-st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "user-icon-st1",
			d: "M16.8,32.5c8.7,0,15.8-7.1,15.8-15.8S25.5,1,16.8,1S1,8,1,16.7S8.1,32.5,16.8,32.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "user-icon-st1",
			d: "M16.8,22c3.6,0,6.6-2.9,6.6-6.6s-2.9-6.6-6.6-6.6s-6.6,2.9-6.6,6.6S13.2,22,16.8,22z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "user-icon-st1",
			d: "M6.3,28.4c1-1.9,2.5-3.6,4.4-4.7c1.9-1.1,4-1.7,6.2-1.7c2.2,0,4.3,0.6,6.2,1.7c1.9,1.1,3.4,2.8,4.4,4.7"
		})
	] }) }) })]
});
export default SvgUserIcon;
